// src/pages/DashboardPage.jsx
import Layoutpp from "../layouts/Layoutpp";
import EditStudentRecordpp from "./EditStudentRecordpp";

const Editstudentrecordpagepp = () => {

  return (
    <Layoutpp title="Edit Student Record">
        {/* Main Content */}
        <div style={{ flex: 1 }}>
          <EditStudentRecordpp/>
        </div>
    </Layoutpp>
  );
};

export default Editstudentrecordpagepp;
